// Mock data for Medical Tourism Website

export const treatments = [
  {
    id: 1,
    title: "Heart Surgery",
    description: "Advanced cardiac procedures including bypass surgery, valve replacement, and minimally invasive heart treatments.",
    icon: "Heart",
    price: "Starting from $8,000",
    duration: "7-14 days",
    image: "https://images.unsplash.com/photo-1758206523711-f20bb01033a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzdXJnaWNhbCUyMG9wZXJhdGlvbnxlbnwwfHx8fDE3Njk5MzUyNDJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Orthopedic Surgery",
    description: "Joint replacement, spine surgery, sports injury treatment, and advanced orthopedic care.",
    icon: "Bone",
    price: "Starting from $5,000",
    duration: "5-10 days",
    image: "https://images.unsplash.com/photo-1758206523789-e2af7f7b7e75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxzdXJnaWNhbCUyMG9wZXJhdGlvbnxlbnwwfHx8fDE3Njk5MzUyNDJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Cancer Care",
    description: "Comprehensive oncology treatment including chemotherapy, radiation, and surgical interventions.",
    icon: "Activity",
    price: "Starting from $6,000",
    duration: "Variable",
    image: "https://images.unsplash.com/photo-1719934398679-d764c1410770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbHxlbnwwfHx8fDE3Njk5MzUyNTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Cosmetic Surgery",
    description: "Aesthetic procedures including rhinoplasty, liposuction, and facial rejuvenation treatments.",
    icon: "Sparkles",
    price: "Starting from $3,000",
    duration: "3-7 days",
    image: "https://images.pexels.com/photos/7250797/pexels-photo-7250797.jpeg"
  },
  {
    id: 5,
    title: "IVF Treatment",
    description: "Advanced fertility treatments with high success rates and personalized care protocols.",
    icon: "Baby",
    price: "Starting from $4,000",
    duration: "2-3 weeks",
    image: "https://images.unsplash.com/photo-1764727291644-5dcb0b1a0375?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMGxvYmJ5fGVufDB8fHx8MTc2OTkzNTE5MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Dental Care",
    description: "Complete dental solutions including implants, cosmetic dentistry, and oral surgery.",
    icon: "Smile",
    price: "Starting from $500",
    duration: "2-5 days",
    image: "https://images.unsplash.com/photo-1764885449418-db6632922a19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzY5OTM1MjA3fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "International Patient Support",
    description: "Dedicated support team available 24/7 for international patients",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Visa Assistance",
    description: "Complete visa support and medical visa invitation letters",
    icon: "FileCheck"
  },
  {
    id: 3,
    title: "Airport Pickup",
    description: "Complimentary airport transfer and local transportation",
    icon: "Plane"
  },
  {
    id: 4,
    title: "Translator Support",
    description: "Professional medical translators in multiple languages",
    icon: "Languages"
  },
  {
    id: 5,
    title: "Luxury Recovery Rooms",
    description: "Comfortable private rooms with modern amenities",
    icon: "Hotel"
  },
  {
    id: 6,
    title: "Affordable Pricing",
    description: "World-class care at 60-80% lower costs than Western countries",
    icon: "DollarSign"
  }
];

export const hospitalPartners = [
  { id: 1, name: "Apollo Hospitals", logo: "Apollo" },
  { id: 2, name: "Fortis Healthcare", logo: "Fortis" },
  { id: 3, name: "Max Healthcare", logo: "Max" },
  { id: 4, name: "Medanta", logo: "Medanta" },
  { id: 5, name: "Narayana Health", logo: "Narayana" },
  { id: 6, name: "Manipal Hospitals", logo: "Manipal" }
];

export const patientJourney = [
  {
    step: 1,
    title: "Free Consultation",
    description: "Share your medical reports and get expert consultation online"
  },
  {
    step: 2,
    title: "Treatment Plan",
    description: "Receive personalized treatment plan with cost estimates"
  },
  {
    step: 3,
    title: "Visa & Travel",
    description: "We assist with visa processing and arrange your travel"
  },
  {
    step: 4,
    title: "Arrival & Pickup",
    description: "Airport pickup and comfortable accommodation arrangements"
  },
  {
    step: 5,
    title: "Medical Treatment",
    description: "World-class treatment at premier Indian hospitals"
  },
  {
    step: 6,
    title: "Recovery & Return",
    description: "Post-treatment care and safe return to your home country"
  }
];

// The fabricated patient testimonials that lived here have been removed.
// They paired invented names and outcomes with Unsplash stock portraits and
// were rendered under the heading "Real experiences from international
// patients". Real, consented testimonials belong in src/data/testimonials.js.

export const aboutIndia = [
  {
    id: 1,
    title: "Affordability",
    description: "Save 60-80% on medical costs compared to Western countries without compromising on quality",
    icon: "TrendingDown"
  },
  {
    id: 2,
    title: "Advanced Hospitals",
    description: "JCI-accredited hospitals with cutting-edge technology and world-class infrastructure",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Expert Doctors",
    description: "Internationally trained doctors with decades of experience in their specialties",
    icon: "Stethoscope"
  }
];
